import cn from 'classnames'
import { formatMoneyInteger } from 'legacy/lut/components/widgets/public/partner360/helpers/formatMoneyInteger'
import { useMemo } from 'react'

import { TPopupHorizontal } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'

import styles from './GrowField.module.scss'

interface IProps {
  percent?: number
  isPaleColor?: boolean
  isNoColor?: boolean
  className?: string
  isEmpty?: boolean
  icon?: boolean
  diff?: boolean
  achiev?: boolean
  fractionDigits?: number
}

export const GrowField = ({
  percent,
  isPaleColor = false,
  isNoColor = false,
  className,
  isEmpty = false,
  icon = false,
  diff = false,
  achiev = false,
  fractionDigits = 0,
}: IProps) => {
  /** -------------------- Variables ----------------------- */

  const plusPrefix = '+'
  const noColor = '#555555'
  const greenColor = useMemo(() => {
    const color = isPaleColor ? '#00B649' : '#00B649'

    return isNoColor ? noColor : color
  }, [isNoColor, isPaleColor])
  const redColor = useMemo(() => {
    const color = isPaleColor ? '#F36794' : '#F36794'

    return isNoColor ? noColor : color
  }, [isNoColor, isPaleColor])
  const grayColor = useMemo(() => {
    const color = isPaleColor ? '#B9B9B9' : '#B9B9B9'

    return isNoColor ? noColor : color
  }, [isNoColor, isPaleColor])
  const suffix = useMemo(() => (!diff ? '%' : 'pt'), [diff])
  const formattedPercent = useMemo(
    () => formatMoneyInteger(percent ?? 0, fractionDigits) + suffix,
    [fractionDigits, percent, suffix]
  )

  /** -------------------- Render ----------------------- */

  if ((!percent && percent !== 0) || !isFinite(percent)) {
    return <div className={cn(styles.root, className)}>-</div>
  }

  if (!icon) {
    return achiev ? (
      <div className={cn(styles.root, className)}>
        {percent >= 100 ? (
          <span style={{ color: greenColor }}>{formattedPercent}</span>
        ) : percent < 100 && percent > 0 ? (
          <span style={{ color: redColor }}>{formattedPercent}</span>
        ) : (
          <span style={{ color: grayColor }}>{formattedPercent}</span>
        )}
      </div>
    ) : (
      <div className={cn(styles.root, className)}>
        {percent > 0 ? (
          <span style={{ color: greenColor }}>
            {plusPrefix}
            {formattedPercent}
          </span>
        ) : percent < 0 ? (
          <span style={{ color: redColor }}>{formattedPercent}</span>
        ) : (
          <span style={{ color: grayColor }}>{formattedPercent}</span>
        )}
      </div>
    )
  }

  return isEmpty ? (
    <div className={cn(styles.root, className)}>
      <i className={'kbase'} />
    </div>
  ) : (
    <Tooltip
      horizontalStartPosition={TPopupHorizontal.Right}
      horizontalDirection={TPopupHorizontal.Right}
      tipContent={() => <span>{formattedPercent}</span>}
    >
      <div className={cn(styles.root, className)}>
        {percent > 0 ? (
          <i className={'kbase kbase-arrow-top'} style={{ color: greenColor }} />
        ) : percent < 0 ? (
          <i className={'kbase kbase-arrow-bottom'} style={{ color: redColor }} />
        ) : (
          <i className={'kbase kbase-arrow-right'} style={{ color: grayColor }} />
        )}
      </div>
    </Tooltip>
  )
}
